import React from 'react';
import {connect} from 'react-redux';
var Modal = require('react-modal');
import Textarea from 'react-textarea-autosize';
import ShowMoreText from 'react-show-more-text';
import {IndexLink,Link,withRouter} from 'react-router';
import Loading from 'react-loading';
var querystring = require('querystring');
import axios from 'axios';
import Comment from "../../../appcomponents/commons/experiential/Comment";

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: '999',
        overflow: 'auto'
    },
    content: {
        top: '15%',
        left: '50%',
        padding: '0',
        maxWidth: '700px',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        marginBottom: '2%',
        transform: 'translate(-50%, -15%)',
        zIndex: '999',
        maxHeight: '97vh',
        overflowX: 'hidden'
    }
};
const file_limit = 25 * 1024 * 1024;
var isloaded = false;

class ChallengeExperientialItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            studentArr: [],
            tasks: [],
            currentTask: [],
            currentTaskStudents: [],

            detail: false,
            isLoadingDetail: false,
            openTeam: false,

            task_detail: [],
            leftOpend: false,
            id_joined: 0,

            //submit work
            showPopover: false,
            justPost: 0,
            files: {},
            message: '',

            //popover
            lableSubmit: "Submit challenge"
        };
    }

    componentWillMount = () => {
        this.setState({tasks: this.props.tasks}, () => {
            this.renderStudents()
        })
    }

    componentDidMount = () => {}

    componentWillUnmount = () => {}

    componentWillReceiveProps = (nextProps) => {
        this.setState({tasks: nextProps.tasks}, () => {
            this.renderStudents()
        })
    }

    renderStudents = () => {
        let tasks = this.state.tasks
        let idx = 0
        let studentArr = []
        let student = []
        for (var task of tasks) {
            student = task.profile
            idx++
            studentArr.push(
                <tr key={"team-project-"+task.id_joined}>
                    <td>
                        <div className="feed-shared-actor__meta relative pd30">
                        <span onClick={this.handleItemClick.bind(this, task, task.id_joined)} className="feed-shared-actor__description t-12 t-bold t-black--light">
                            <span className="linkto">{idx}. <img key={'u-key-5'} className="img_circle" src={student.avatar} /> {student.full_name}</span>
                        </span>
                        </div>
                    </td>
                    <td>
                        <div className="feed-shared-actor__meta relative">
                        <span className="feed-shared-actor__description t-12 t-bold t-black--light">
                            <a className="green">
                                <span className="circle">-</span>
                                <span className="title">Completed</span>
                            </a>
                        </span>
                            <span className="feed-shared-actor__title display-flex">
                            <img src="/static/img/eappimg/pj/icon-calendar-black2.png"/>
                            <span className="feed-shared-actor__description pdlt t-12 t-normal t-black">
                                {task.start_date}
                            </span>
                        </span>
                        </div>
                    </td>
                    <td>
                        <div className="feed-shared-actor__meta relative">
                        <span className="feed-shared-actor__description t-12 t-normal t-black">
                            1 | 1 Completed
                        </span>
                        </div>
                    </td>
                    <td>
                        <div className="feed-shared-actor__meta relative">
                        <span className="feed-shared-actor__description t-12 t-bold">
                            <a className={task.status.class}>
                                <span className="circle">-</span>
                                <span className="title">{task.status.txt}</span>
                            </a>
                        </span>
                            <span className="feed-shared-actor__title display-flex">
                            <img src="/static/img/eappimg/pj/icon-calendar-black2.png"/>
                            <span className="feed-shared-actor__description pdlt t-12 t-normal t-black">
                                Due {task.end_date}
                            </span>
                        </span>
                        </div>
                    </td>
                    <td className="feedback-title">
                        <div className="rating-container theme-krajee-fa rating-xs rating-animate">
                            <div className="rating">
                        <span className="empty-stars">
                            <span className="star">
                                <i className="fa fa-star-o"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star-o"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star-o"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star-o"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star-o"></i>
                            </span>
                        </span>
                        <span className="filled-stars" style={{width: task.feedback + "%"}}>
                            <span className="star">
                                <i className="fa fa-star"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star"></i>
                            </span>
                            <span className="star">
                                <i className="fa fa-star"></i>
                            </span>
                        </span>
                            </div>
                        </div>
                    </td>
                </tr>
            )
        }

        this.setState({studentArr: studentArr})
    }

    handleItemClick = (task, id_joined, evt) => {
        this.setState({detail: true, currentTask: task}, () => {
            let url = "/code/api_experiences.php?api=getTask";
            let data = new FormData();
            data.append('id_joined', id_joined);
            axios.post(url, data)
                .then(response => {

                    let rst = response.data;
                    let currentTask = this.state.currentTask

                    if (parseInt(rst.status) === 1) {
                        currentTask['files'] = rst.data.files
                        currentTask['enable_ask'] = rst.data.enable_ask
                        this.setState({ task_detail: rst.data, currentTask: currentTask, currentTaskStudents: rst.data.students, isLoadingDetail: false, leftOpend: 1, id_joined: id_joined });
                    }
                }).catch(error => {
            });
        })
    }

    handleDetailCloseClick = (e) => {
        this.setState({detail: false, leftOpend: 0, currentTask: []})
    }

    //submit work
    handleSubmitClick = () => {
        this.setState({showPopover: true, message: '', files: {}})
    }

    closeModal = () => {
        this.setState({showPopover: false});
    }

    handleMessageChange = (e) => {
        this.setState({message: e.target.value});
    }

    handleAttClick = (event) => {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleFileUpload = (event) => {

        if (event.target.files.length > 0) {

            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var allowedExtensions = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'pdf', 'zip', 'rar', '7z', 'rtf'];
            var imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];

            if (imageExt.indexOf(Extension) !== -1 || allowedExtensions.indexOf(Extension) !== -1) {
                var data = new FormData();
                data.append('file', fileUpload);
                axios.post('/code/api_experiences.php?api=uploadExperiential',data)
                    .then(response => {
                        if(parseInt(response.data.status) === 1)
                        {
                            isloaded = true;
                            this.setState({files: response.data.data});
                        }
                        else {
                            commonApi.showAlert(response.data.message);
                        }
                    });
            }
            else {
                commonApi.showAlert("Only accept: documents, images, compress files");
                this.refs.file_input.value = '';
            }
        }
    }

    handlePostSubmitWorkClick = (joined, e) => {
        if (this.state.isSubmited === true) {
            return false;
        }
        this.setState({ isSubmited: true, lableSubmit: "Processing" })
        let url = "/code/api_experiences.php?api=updateProjectTask";
        var params = Object.assign({},
            this.state.files,
            {
                id_joined: joined,
                act: 'submit',
                msg: this.state.message,
            }
        )
        axios.post(url, querystring.stringify(params))
            .then(response => {

                let rst = response.data;
                let rst_data = rst.data;

                if (parseInt(rst.status) === 1) {
                    this.setState({ justPost: 1, showPopover: false, tasks: rst_data.tasks, team_detail: rst_data.team_detail, currentTask: rst_data.team_detail }, () => {
                        this.renderStudents()
                        this.handleItemClick(rst_data.team_detail, rst_data.team_detail.id_joined)
                    });
                }
                else {
                    commonApi.showAlert("There was an error. Please try again");
                }
            }).catch(error => {
        });
    }

    executeOnClick = () => {

    }

    render() {
        let currentTask = this.state.currentTask

        let context = ""
        let taskDetail = []
        let studentArr = []
        let filesArr = []
        if (currentTask.id_joined > 0) {
            context = <div
                dangerouslySetInnerHTML={{__html: currentTask ? currentTask.description : ""}}>
            </div>;

            let students = this.state.currentTaskStudents
            let st_avatar = null
            if (students !== undefined) {
                for (var taskStudent of students) {
                    st_avatar = taskStudent.image_avatar_account > 0 ? taskStudent.avatar : '/static/img/appimg/common-noavatar-sm.jpg'
                    studentArr.push(
                        <img key={"student-team-" + taskStudent.id_account} className="img_circle_s slist_item" src={st_avatar} alt={taskStudent.full_name}/>
                    )
                }
            }

            taskDetail = this.state.task_detail

            let files = currentTask.files
            if (files !== undefined) {
                for (var item of currentTask.files) {
                    filesArr.push(
                        <div key={"files-" + item.id_file} className="col-sm-12 text-left mrb-10 attach-area">
                            <a href={item.link_file} target="_blank">{item.name_file}</a>
                        </div>
                    )
                }
            }
        }

        return (
            <div>
                <div className="extent-team">
                    <table className="table challenge-table">
                        <thead>
                        <tr>
                            <th className="w20p text-left pd30">Name</th>
                            <th className="w20p text-left">Start</th>
                            <th className="w20p text-left">Milestones</th>
                            <th className="w20p text-left">Final submission</th>
                            <th className="w20p text-left">Feedback</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.studentArr}
                        </tbody>
                    </table>
                </div>

                <div className={this.state.detail ? "container-task-detail" : "hide-el"}>
                    <div id="pj-task-detail" className="task-detail">
                        {this.state.isLoadingDetail ? <div className="center_div"><Loading type='bubbles' color='rgba(82, 158, 204, 1)' width={20} height={20}/></div> :
                            <div>
                                <div className="task-div-detail">
                                    <table className="task-table-detail">
                                        <tbody>
                                        <tr>
                                            <td>
                                                {parseInt(currentTask.status_id) < 3 ?
                                                    <span onClick={this.handleSubmitClick.bind(this)} className="img_complate"> Submit Work</span>
                                                    :
                                                    <span className="img_submit_work"> Submitted</span>
                                                }
                                            </td>
                                            <td>
                                                &nbsp;
                                            </td>
                                            <td className="text-right">
                                                <img onClick={this.handleDetailCloseClick.bind(this)} className="narrow-close" src="/static/img/appimg/narrow-close.png"/>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colSpan={3}>{currentTask.name}</th>
                                        </tr>
                                        <tr>
                                            <th className="w-8p">Assignee</th>
                                            <td>
                                                <div className="slist">
                                                    {studentArr}
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Due date</th>
                                            <td colSpan={2} className="due-date-class">
                                                <img className="img_avatar" src="/static/img/appimg/m_calendar.png"/> {currentTask.end_date}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Description</th>
                                            <td colSpan={2} >
                                                <ShowMoreText
                                                    lines={3}
                                                    more='Show more'
                                                    less='Show less'
                                                    anchorClass=''
                                                    onClick={this.executeOnClick}
                                                >
                                                    {context}
                                                </ShowMoreText>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Attached File</th>
                                            <td colSpan={2} >
                                                {filesArr}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <Comment
                                    user={this.props.user[0]}
                                    joined={taskDetail}
                                    enable_ask={parseInt(currentTask.enable_ask)}
                                    justPost={parseInt(this.state.justPost)}
                                    leftOpend={this.state.leftOpend}
                                    id_joined={this.state.id_joined}
                                />
                            </div>
                        }
                    </div>
                </div>

                <Modal
                    isOpen={this.state.showPopover}
                    onRequestClose={this.closeModal.bind(this)}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Submit Challenge to ..."
                >
                    <div id="submit-and-request">
                        <div className={"items headding"}>
                            <div className={"title"}>Submit Challenge to {this.props.company_name}</div>
                            <button className="close" onClick={this.closeModal.bind(this)}>X</button>
                        </div>
                        <div className={"items contents form-horizontal"}>
                            <div className="form-group">
                                <label className="control-label col-sm-12 text-left mrb-10" htmlFor="pwd">Cover letter</label>
                                <div className="col-sm-12">
                                    <Textarea
                                        name="message"
                                        className={"form-control"}
                                        maxRows={10}
                                        minRows={10}
                                        value={this.state.message}
                                        onChange={this.handleMessageChange.bind(this)}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-12 text-left mrb-10" htmlFor="pwd">Attachments</label>
                                {this.state.filesArr}
                                <div className="col-sm-12 txt-lab">
                                    <span className="upd-area">
                                        drag or <a onClick={this.handleAttClick.bind(this)}>upload</a> project files
                                    </span>
                                    <input ref="file_input"
                                           className="hide-el"
                                           type="file"
                                           onChange={this.handleFileUpload.bind(this)}
                                           accept=".xlsx,.xls,image/*,.doc, .docx,.ppt,.pptx,.txt,.pdf,.zip,.rar,.7z,.rtf"/>
                                    <span className="t-lab-b ptb70 txt-rec">
                                        You may attach up to 10 files under the size of 25MB each. Include work drag or upload challenge files or other documents to support challenge application.
                                        Do not attach your resume - Your Versity profile is automatically forwarded to the client with your proposal.
                                    </span>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="col-sm-offset-2 col-sm-10 text-right">
                                    <a onClick={this.handlePostSubmitWorkClick.bind(this, currentTask.id_joined)} className="btn_v btn_confirm">{this.state.lableSubmit}</a>
                                    <a className="btn_v btn_cancel mgl-10" onClick={this.closeModal.bind(this)}>Cancel</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

            </div>
        );
    }
}

ChallengeExperientialItem.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

const mapStateToProps = function (store) {
    return {
        user: store.userState.user
    };
};

export default connect(mapStateToProps)(withRouter(ChallengeExperientialItem));



/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/challenge-experiential/item.js
 **/